import getUserInfo from './getUserInfo'
import loginCredentialUser from './loginCredentialUser'
import loginMFAUser from './loginMFAUser'
import loginMultiTenantUser from './loginMultiTenantUser'
import loginSSOUser from './loginSSOUser'
import validateRedirect from './validateRedirect'

export default {
    getUserInfo,
    validateRedirect,
    loginMFAUser,
    loginSSOUser,
    loginCredentialUser,
    loginMultiTenantUser,
}
